var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightSales({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39961 4.06176C9.39961 5.38724 8.32509 6.46176 6.99961 6.46176C5.67412 6.46176 4.59961 5.38724 4.59961 4.06176M2.15112 12.4618H11.8481C12.705 12.4618 13.3996 11.78 13.3996 10.9391L12.4057 2.06174C12.4057 1.22079 11.711 0.539062 10.8542 0.539062H2.95112C2.09425 0.539062 1.39961 1.22079 1.39961 2.06174L0.599609 10.9391C0.599609 11.78 1.29425 12.4618 2.15112 12.4618Z",
    stroke: "black",
    strokeWidth: 0.886871,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightSales);
export default __webpack_public_path__ + "static/media/LightSales.65d91ff4f38b0057b7e4b6341230253d.svg";
export { ForwardRef as ReactComponent };